export default __webpack_public_path__ + "upload/close-menu.bdd7ca90.svg";